(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("antd"), require("antdCssinjs"), require("icons"), require("mermaid"));
	else if(typeof define === 'function' && define.amd)
		define([, , , , , ], factory);
	else if(typeof exports === 'object')
		exports["antdx"] = factory(require("react"), require("react-dom"), require("antd"), require("antdCssinjs"), require("icons"), require("mermaid"));
	else
		root["antdx"] = factory(root["React"], root["ReactDOM"], root["antd"], root["antdCssinjs"], root["icons"], root["mermaid"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__40868__, __WEBPACK_EXTERNAL_MODULE__41238__, __WEBPACK_EXTERNAL_MODULE__49999__, __WEBPACK_EXTERNAL_MODULE__10283__, __WEBPACK_EXTERNAL_MODULE__25377__, __WEBPACK_EXTERNAL_MODULE__87798__) {
return 